import OpenRotorMark from '@/components/base/OpenRotorMark';
import { assets } from '@/mocks/home';

const SPECS: Array<[string, string]> = [
  ['Supply model', 'Supplier / distributor'],
  ['Scope', 'Valves · actuators · accessories'],
  ['Support', 'Selection & documentation'],
  ['Process', 'B2B quotation'],
];

/** Scene 02 copy — shared by the pinned 3D sequence and the static fallback. */
export function Scene02Copy() {
  return (
    <div>
      <h2 className="h-section text-foreground-950">CONTROL AT EVERY CONNECTION.</h2>
      <p className="mt-8 t-body text-foreground-600 max-w-md">Industrial valves and flow-control components, selected for dependable performance and efficient procurement.</p>
      <dl className="mt-10 grid grid-cols-2 gap-x-6 border-t border-background-200">
        {SPECS.map(([k, val]) => (
          <div key={k} className="py-5 border-b border-background-200">
            <dt className="eyebrow text-foreground-600">{k}</dt>
            <dd className="mt-2 t-body text-foreground-950">{val}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

/** Scene 03 copy. */
export function Scene03Copy({ center = false }: { center?: boolean }) {
  return (
    <div className={center ? 'text-center flex flex-col items-center' : ''}>
      <h2 className="h-section text-foreground-950">EVERY DETAIL MATTERS.</h2>
      <p className="mt-8 max-w-md t-body text-foreground-600">The NORTHLINE mark is drawn from the handwheel — outer ring, hub and three spokes. The point where control begins.</p>
    </div>
  );
}

/**
 * Static fallback for Scenes 02 & 03 — only rendered when the pinned 3D sequence is off
 * (mobile, reduced motion). On desktop the same copy lives inside the sequence.
 */
export default function StoryScenes() {
  return (
    <>
      <section id="scene-02" className="bg-background-50">
        <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-12 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 reveal"><Scene02Copy /></div>
          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <div className="relative w-full h-[380px] md:h-[560px] flex items-center justify-center">
              <img src={assets.gateValve} alt="Gate valve profile" title="Gate valve - NORTHLINE" className="relative h-[86%] w-auto object-contain" />
            </div>
          </div>
        </div>
      </section>
      <section id="scene-03" className="bg-background-50 border-t border-background-200">
        <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-12 py-24 md:py-32 flex flex-col items-center reveal">
          <Scene03Copy center />
          <div className="mt-14 w-[220px] h-[220px] md:w-[300px] md:h-[300px] flex items-center justify-center">
            <OpenRotorMark size={300} title="NORTHLINE Open Rotor" className="w-full h-full" />
          </div>
        </div>
      </section>
    </>
  );
}